/* ============================================================
   BeyGamer Theme JS
   ============================================================ */
(function () {
  'use strict';

  const qs = (s, ctx = document) => ctx.querySelector(s);
  const qsa = (s, ctx = document) => Array.from(ctx.querySelectorAll(s));

  const backdrop = qs('[data-overlay-backdrop]');

  function openBackdrop() { if (backdrop) backdrop.classList.add('is-active'); }
  function closeBackdrop() { if (backdrop) backdrop.classList.remove('is-active'); }

  /* ---------------- Sticky header on scroll ---------------- */
  const header = qs('[data-header]');
  if (header) {
    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > 30) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Announcement bar close ---------------- */
  const announcement = qs('[data-announcement-bar]');
  const announcementClose = qs('[data-announcement-close]');
  if (announcement && announcementClose) {
    if (sessionStorage.getItem('bg_announcement_closed') === '1') {
      announcement.setAttribute('hidden', '');
    }
    announcementClose.addEventListener('click', () => {
      announcement.setAttribute('hidden', '');
      sessionStorage.setItem('bg_announcement_closed', '1');
    });
  }

  /* ---------------- Mobile menu ---------------- */
  const nav = qs('[data-nav]');
  const menuToggle = qs('[data-menu-toggle]');
  function openMenu() {
    if (!nav) return;
    nav.classList.add('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-nav-open');
    openBackdrop();
  }
  function closeMenu() {
    if (!nav) return;
    nav.classList.remove('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-nav-open');
    if (!anyOverlayOpen()) closeBackdrop();
  }
  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      nav.classList.contains('is-open') ? closeMenu() : openMenu();
    });
  }

  /* ---------------- Search overlay ---------------- */
  const searchOverlay = qs('#SearchOverlay');
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    const input = qs('.search-overlay__input', searchOverlay);
    setTimeout(() => input && input.focus(), 60);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }
  qsa('[data-search-open]').forEach(b => b.addEventListener('click', openSearch));
  qsa('[data-search-close]').forEach(b => b.addEventListener('click', closeSearch));

  /* ---------------- Cart drawer ---------------- */
  const cartDrawer = qs('#CartDrawer');
  const cartBody = qs('[data-cart-body]');

  function anyOverlayOpen() {
    return (cartDrawer && cartDrawer.classList.contains('is-open')) ||
           (nav && nav.classList.contains('is-open'));
  }
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    openBackdrop();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (!anyOverlayOpen()) closeBackdrop();
  }
  qsa('[data-cart-open]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-close]')) closeCart();
  });

  if (backdrop) {
    backdrop.addEventListener('click', () => { closeCart(); closeMenu(); });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeMenu(); closeSearch(); }
  });

  /* ---------------- Cart helpers ---------------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(el => { el.textContent = count; });
  }

  function refreshCartDrawer() {
    return fetch('/?section_id=cart-drawer-fragment')
      .then(r => r.ok ? r.text() : null)
      .catch(() => null)
      .then(html => {
        // Fallback: fetch cart.js and rebuild via section rendering
        return fetch('/cart.js').then(r => r.json());
      })
      .then(cart => {
        if (cart) {
          updateCartCount(cart.item_count);
          rebuildDrawer(cart);
        }
      });
  }

  function rebuildDrawer(cart) {
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p>Your cart is empty</p>' +
        '<a href="/collections/all" class="btn btn--accent" data-cart-close>Continue Shopping</a>' +
        '</div>';
      return;
    }
    let items = '<ul class="cart-drawer__items" role="list">';
    cart.items.forEach(item => {
      const img = item.image ? '<img src="' + item.image + '" alt="" width="80" height="80">' : '';
      const variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';
      items +=
        '<li class="cart-item" data-cart-item>' +
          '<a href="' + item.url + '" class="cart-item__media">' + img + '</a>' +
          '<div class="cart-item__details">' +
            '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
            variant +
            '<p class="cart-item__price">' + formatMoney(item.final_price) + '</p>' +
            '<div class="cart-item__actions">' +
              '<div class="qty-selector">' +
                '<button type="button" class="qty-selector__btn" data-qty-change="' + item.key + '" data-qty="minus">&minus;</button>' +
                '<input type="text" class="qty-selector__input" value="' + item.quantity + '" data-qty-input="' + item.key + '" readonly>' +
                '<button type="button" class="qty-selector__btn" data-qty-change="' + item.key + '" data-qty="plus">&plus;</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-cart-remove="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    });
    items += '</ul>';
    items +=
      '<div class="cart-drawer__footer">' +
        '<div class="cart-drawer__subtotal"><span>Subtotal</span>' +
        '<span class="cart-drawer__subtotal-price">' + formatMoney(cart.total_price) + '</span></div>' +
        '<p class="cart-drawer__note">Taxes and shipping calculated at checkout</p>' +
        '<form action="/cart" method="post"><button type="submit" name="checkout" class="btn btn--accent btn--full">Checkout</button></form>' +
        '<a href="/collections/all" class="cart-drawer__continue" data-cart-close>Continue Shopping</a>' +
      '</div>';
    cartBody.innerHTML = items;
  }

  /* ---------------- Add to cart (AJAX) ---------------- */
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"], .product-card__add-form, .product__form');
    if (!form) return;
    // Only intercept product add forms
    if (!form.querySelector('[data-add-to-cart]')) return;
    e.preventDefault();

    const btn = form.querySelector('[data-add-to-cart]');
    const originalText = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding...'; }

    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(r => r.json())
      .then(() => refreshCartDrawer())
      .then(() => {
        if (btn) { btn.innerHTML = 'Added \u2713'; }
        openCart();
        setTimeout(() => { if (btn) { btn.disabled = false; btn.innerHTML = originalText; } }, 1200);
      })
      .catch(() => {
        if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
      });
  });

  /* ---------------- Update / remove cart items ---------------- */
  function changeCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        rebuildDrawer(cart);
        // If on cart page, reload to reflect changes
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
        return cart;
      });
  }

  document.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeCartItem(removeBtn.getAttribute('data-cart-remove'), 0);
      return;
    }
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.getAttribute('data-qty-change');
      const dir = qtyBtn.getAttribute('data-qty');
      const input = qs('[data-qty-input="' + key + '"]');
      let val = input ? parseInt(input.value, 10) : 1;
      val = dir === 'plus' ? val + 1 : Math.max(0, val - 1);
      changeCartItem(key, val);
      return;
    }
  });

  /* ---------------- Product page qty selector ---------------- */
  qsa('[data-qty-page]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = qs('[data-qty-page-input]');
      if (!input) return;
      let val = parseInt(input.value, 10) || 1;
      val = btn.getAttribute('data-qty-page') === 'plus' ? val + 1 : Math.max(1, val - 1);
      input.value = val;
    });
  });

  /* ---------------- Product gallery ---------------- */
  const mainImage = qs('#ProductMainImage');
  qsa('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.getAttribute('data-thumb');
      qsa('.product__thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* ---------------- Product variant selection ---------------- */
  const productForm = qs('[data-product-form]');
  const variantSelect = qs('[data-variant-select]');
  if (productForm && variantSelect) {
    const selectors = qsa('[data-option-selector]', productForm);
    const priceWrapper = qs('[data-price-wrapper]');

    function getVariantData() {
      const script = qs('#ProductVariantsJSON');
      if (script) { try { return JSON.parse(script.textContent); } catch (e) {} }
      return null;
    }

    function updateVariant() {
      const selected = [];
      const groups = {};
      selectors.forEach(s => {
        if (s.checked) groups[s.name] = s.value;
      });
      // Update swatch styling
      qsa('.product__swatch').forEach(sw => {
        const input = sw.querySelector('input');
        sw.classList.toggle('is-selected', input && input.checked);
      });
    }
    selectors.forEach(s => s.addEventListener('change', updateVariant));
    updateVariant();
  }

  /* ---------------- Collection sort ---------------- */
  const sortBy = qs('[data-sort-by]');
  if (sortBy) {
    sortBy.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ---------------- Address forms toggle ---------------- */
  qsa('[data-address-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.getAttribute('data-address-toggle');
      const el = target === 'new' ? qs('#AddressNew') : qs('#AddressEdit_' + target);
      if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none';
    });
  });
  const recoverShow = qs('[data-recover-show]');
  const recoverHide = qs('[data-recover-hide]');
  const recoverPanel = qs('#RecoverPassword');
  const loginPanel = qs('#CustomerLogin');
  if (recoverShow && recoverPanel && loginPanel) {
    recoverShow.addEventListener('click', (e) => { e.preventDefault(); recoverPanel.style.display = 'block'; loginPanel.style.display = 'none'; });
  }
  if (recoverHide && recoverPanel && loginPanel) {
    recoverHide.addEventListener('click', (e) => { e.preventDefault(); recoverPanel.style.display = 'none'; loginPanel.style.display = 'block'; });
  }
  qsa('[data-address-delete]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (!confirm('Are you sure you want to delete this address?')) e.preventDefault();
    });
  });

  /* ---------------- Scroll reveal ---------------- */
  const revealEls = qsa('.section-heading, .category-card, .product-card, .promo-feature');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    revealEls.forEach(el => io.observe(el));
  }
})();
